/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'route': {
    width: 20,
    height: 18,
    viewBox: '0 0 20 18',
    data: '<path pid="0" d="M17.273 18h-10v-1.8h8.182v-3.6h1.818V18zm-.909-7.415c-.628-.9-3.636-5.053-3.636-6.985a3.637 3.637 0 017.273 0c-.001 1.834-2.686 5.62-3.637 6.985zm0-8.785a1.811 1.811 0 00-1.818 1.8 11.96 11.96 0 001.818 3.761A11.959 11.959 0 0018.182 3.6a1.811 1.811 0 00-1.818-1.8zM3.636 17.785C3.008 16.885 0 12.732 0 10.8a3.637 3.637 0 017.273 0c0 1.834-2.685 5.62-3.637 6.985zm0-8.785a1.811 1.811 0 00-1.818 1.8 11.96 11.96 0 001.818 3.761A11.96 11.96 0 005.454 10.8 1.811 1.811 0 003.636 9z" _fill="#474950" fill-rule="evenodd"/>'
  }
})
